"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SwitchExtended;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Label = _interopRequireDefault(require("./Label"));
var _Description = _interopRequireDefault(require("./Description"));
var _Switch = _interopRequireDefault(require("./Switch"));
var _Space = _interopRequireDefault(require("./Space"));
var _excluded = ["label", "description", "containerSyle", "textContainerStyle", "switchStyle", "fontStyle"];
function SwitchExtended(props) {
  var label = props.label,
    description = props.description,
    containerSyle = props.containerSyle,
    textContainerStyle = props.textContainerStyle,
    switchStyle = props.switchStyle,
    fontStyle = props.fontStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, containerSyle]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.textContainer, textContainerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: fontStyle
  }, label), /*#__PURE__*/_react["default"].createElement(_Description["default"], {
    style: fontStyle
  }, description)), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 12
  }), /*#__PURE__*/_react["default"].createElement(_Switch["default"], (0, _extends2["default"])({
    style: [styles["switch"], switchStyle]
  }, rest)));
}
SwitchExtended.propTypes = {
  label: _propTypes["default"].string,
  description: _propTypes["default"].string
};
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  textContainer: {
    flex: 1
  },
  "switch": {}
});